


























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import debounce from "lodash/debounce";
import {CustomerParams} from "@/modules/customers/params";
import {CommonStatus} from "@/enums/status";
import {listCustomer} from "@/modules/customers/services";

@Component({
    name: "CustomerChildSelector",
})
export default class extends Vue {
    @Prop({type: Boolean, default: false}) readonly autoFocus!: boolean;
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: "default", type: String}) readonly mode!: string;
    @Prop({default: "Chọn khách hàng", type: String}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Prop({default: null, type: String}) readonly parentRowGuid!: string;


    @Model("change")
    readonly customerRowGuid!: string | string[];

    @Emit('change')
    handleChange(value: number) {
        if (!value) {
            this.onSearch(value as any);
        }
        // this.$emit('customer', ti);
        return value;
    }

    customers = []

    @Watch("parentRowGuid", {immediate: true, deep: true})
    onChangeParentRowGuid(val: any) {
        this.searchChild(val);
    }

    async searchChild(parentRowGuid, keyword = '') {
        if (parentRowGuid) {
            try {
                const params = {
                    ...new CustomerParams(),
                    limit: 1000,
                    status: CommonStatus.Active,
                    parentRowGuid: parentRowGuid,
                    search: keyword
                };
                const {data} = await listCustomer(params);

                this.customers = data.datas

            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
            }
        }
    }

    private onSearch = debounce( (value: string) => {
        console.log(value);
        this.searchChild(this.parentRowGuid, value)
    }, 500);
}
